import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgGooglePlusLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#path0_gpi_fill",
			fill: "#DC4E41"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#path1_gpi_fill",
			transform: "matrix(1 0 0 1 89.06 152.628)",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#path2_gpi_fill",
			transform: "matrix(1 0 0 1 330.58 212.971)",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "path0_gpi_fill",
				d: "M256 512c141.385 0 256-114.615 256-256S397.385 0 256 0 0 114.615 0 256s114.615 256 256 256z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "path1_gpi_fill",
				d: "M.065 105.704C-2.002 51.276 45.672.977 100.155.324c27.768-2.368 54.784 8.416 75.799 26.003-8.621 9.478-17.392 18.847-26.76 27.618-18.501-11.24-40.775-19.805-62.396-12.198-34.874 9.93-55.994 51.106-43.088 85.222 10.687 35.632 54.026 55.186 87.992 40.218 17.587-6.298 29.183-22.525 34.271-39.962-20.156-.402-40.318-.151-60.474-.707-.051-11.993-.101-23.94-.051-35.933 33.615-.05 67.279-.15 100.944.15 2.067 29.385-2.268 60.831-21.371 84.415-26.158 33.665-74.484 43.545-113.798 30.338C29.499 191.784-.843 149.75.065 105.704z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "path2_gpi_fill",
				d: "M30.392 0h29.982c.055 10.03.151 20.111.206 30.137 10.026.1 20.106.15 30.137.2v30.037l-30.137.15c-.1 10.082-.15 20.108-.206 30.188-10.026-.05-20.06 0-30.036 0-.096-10.08-.096-20.106-.201-30.137C20.111 60.47 10.03 60.425 0 60.37V30.333c10.03-.05 20.06-.1 30.137-.2.05-10.022.15-20.103.255-30.133z"
			})
		] })
	]
});
export default SvgGooglePlusLogo;
